import { CSSObject } from '@chakra-ui/react';

export const FlexBannerWrapper: CSSObject = {
  px: '4',
  py: '2.5',
  m: 'auto',
  h: '12',
  w: 'container.xl',
};

export const FlexWrapper: CSSObject = {
  boxShadow: '0px 3px 20px 0px rgba(0, 0, 0, 0.3)',
};

export const FlexItemsWrapper: CSSObject = {
  mr: '0',
  columnGap: '1',
  '& > div:last-of-type': { mr: '0' },
  minH: 'full',
};
export const CountdownTimer = {
  '&': {
    '.countdown-flex': {
      background: 'transparent',
    },
  },
};
export const LinkItem: CSSObject = {
  w: '40',
  h: 'full',
  py: '2px',
  borderRadius: 'md',
  bgGradient: 'linear(to-b, alpha.400, alpha.500)',
  color: 'white',
  boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset',
  textOverflow: 'ellipsis',
  fontFamily: 'accent',
  _hover: {
    bgGradient: 'linear(to-b, alpha.500, alpha.500)',
  },
  '.chakra-badge': {
    mr: '1',
    mt: '1.5',
    maxW: '10',
    fontSize: '9px',
  },
};
export const RaceNumber: CSSObject = {
  color: 'white',
};
export const FlexDetails: CSSObject = {
  color: 'white',
  display: 'block',
  maxW: '70px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
};
export const Icon: CSSObject = {
  color: 'alpha.100',
  filter: 'drop-shadow(0px 0px 9px rgba(28, 213, 255, 0.5))',
};
export const FlexButtonContainer: CSSObject = {
  bg: 'transparent',
  pos: 'relative',
  p: '0',
  pl: '1',
  gap: '1',
};
export const ButtonChevron: CSSObject = {
  boxSize: '7',
  minW: '7',
  color: 'beta.300',
  p: '0',
  borderRadius: 'md',
  bgGradient: 'linear(to-b, alpha.400, alpha.500)',
  boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset',
  _hover: {
    bgGradient: 'linear(to-b, alpha.500, alpha.500)',
  },
  '& > svg': {
    boxSize: '6',
    filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
  },
};
